import { cn } from '../utils/cva';

export const AnimatedThreeDots = () => {
  return (
    <div className="flex gap-1.5">
      {Array.from({ length: 3 }).map((_, index) => {
        return (
          <div
            key={index}
            className={cn('bg-primary1 h-1.5 w-1.5 rounded-full')}
            style={{
              animationName: 'animate-loading-bounce',
              animationDuration: '1s',
              animationIterationCount: 'infinite',
              animationTimingFunction: 'ease-in-out',
              animationDelay: `${(index + 1) * 200}ms`,
            }}
          />
        );
      })}
    </div>
  );
};
